<template>
    <nav id="PowerScanPageFooter" class="navbar navbar-expand-sm navbar-powerscan navbar-light">
      <ul class="navbar-nav mr-auto">
        <li :class="['nav-item nav-item-home', { 'active': currentNav == '/power-scan' } ]">
          <a class="nav-link" href="#" @click.prevent="navigate('/power-scan')">
            <span><HomeIcon/></span>
            <small>Home</small>
          </a>
        </li>

        <li :class="['nav-item nav-item-box-receiving', { 'active': currentNav == '/power-scan/pick-by-bin' } ]">
          <a class="nav-link" href="#" @click.prevent="navigate('/power-scan/pick-by-bin')">
            <span><BoxReceivingIcon/></span>
            <small>Pick By Bin</small>
          </a>
        </li>

        <li :class="['nav-item nav-item-item-transfers', { 'active': currentNav == '/power-scan/xfer-to-bin-location' } ]">
          <a class="nav-link" href="#" @click.prevent="navigate('/power-scan/xfer-to-bin-location')">
            <span><ItemTransfersIcon/></span>
            <small>Item Transfers</small>
          </a>
        </li>

        <li :class="['nav-item nav-item-pick-lists', { 'active': currentNav == '/power-scan/pick-lists' } ]">
          <a class="nav-link" href="#" @click.prevent="navigate('/power-scan/pick-lists')">
            <span><PickListsIcon/></span>
            <small>Pick Lists</small>
          </a>
        </li>

        <!-- <li :class="['nav-item nav-item-bin-movement', { 'active': currentNav == '/power-scan/bin-movement' } ]">
          <a class="nav-link" href="#" @click.prevent="navigate('/power-scan/bin-movement')">
            <span><BinMovementIcon/></span>
            <small>Bin Movement</small>
          </a>
        </li> -->

      </ul>
    </nav>
</template>
<script>
    import HomeIcon from '../../../icons/HomeIcon'
    import BoxReceivingIcon from '../../../icons/BoxReceivingIcon'
    import ItemTransfersIcon from '../../../icons/ItemTransfersIcon'
    import PickListsIcon from '../../../icons/PickListsIcon'
    import BinMovementIcon from '../../../icons/BinMovementIcon'

    export default {
      name: 'PowerScanPageFooter',
      components: {
        HomeIcon,
        BoxReceivingIcon,
        ItemTransfersIcon,
        PickListsIcon,
        BinMovementIcon,
      },
      computed:{
        currentNav() {
            return this.$route.path
        },
      },
      methods: {
        navigate(target){
            if(target != this.currentNav) this.$router.push(target);
        }
      },
    }
</script>